/*
 *
 * An automated message is ultimately (in this scenario) a representation of a command
 * done by an organiser or host that we show to the user in chat.
 *
 * What we're asking here is: which user did the command?
 * More specifically: is the viewer the one that did the command?
 *
 */
export function isActionFromViewer(message, viewerRole) {
  return message.from_type === viewerRole;
}
